import React from "react"
import CalculatorInputWrapper from "../CalculatorInputWrapper"
import SelectButton from "./SelectButton"
import InputFeedback from "../InputFeedback"
import { iOption } from "../../Structure"

interface iCalculatorSelectInput {
  label: string
  onChange: (e: any) => void
  value: any
  error: string | null // Here "error" takes precedence over "warning"
  warning: string | null
  disable: boolean
  shortInfo: string
  extendedInfo: string
  options?: iOption[]
  showFeedback?: boolean
}

const CalculatorSelectInput: React.FC<iCalculatorSelectInput> = ({
  label,
  onChange,
  value,
  error,
  warning,
  disable,
  shortInfo,
  extendedInfo,
  options,
  showFeedback,
}) => {
  const _onChange = (title: string, value: any) => {
    if (disable) return
    onChange({ target: { value } })
  }

  const getValueFeedback = () => {
    if (!value || isNaN(value)) return null
    return parseFloat(value).toFixed(1)
  }

  return (
    <CalculatorInputWrapper
      label={label}
      unit={null}
      extendedInfo={extendedInfo}
      hideUnit={Boolean(value)}
    >
      <div className="py-2" />
      <div className="grid sm:grid-cols-2 md:grid-cols-5">
        <div className="flex items-center flex-wrap sm:col-span-1 md:col-span-3">
          {options!.map((item: iOption, index: number) => (
            <SelectButton
              selected={item.value.toString() === value}
              key={index}
              onClick={_onChange}
              title={item.display_name}
              value={item.value}
            />
          ))}
        </div>
        <div className="sm:col-span-1 md:col-span-2 flex justify-end mt-4 sm:mt-0">
          <div>
            <InputFeedback
              title={"Value"}
              value={getValueFeedback()}
              show={showFeedback}
              warning={warning}
              info={getValueFeedback() ? null : shortInfo}
              error={error}
            />
          </div>
        </div>
      </div>
    </CalculatorInputWrapper>
  )
}

export default CalculatorSelectInput
